module.exports = __webpack_public_path__ + "static/media/hint-icon.bdd8ede8.svg";